(function(root) {
  'use strict';
  function payload(email, list, source) {
    return {data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:list}}}}};
  }
  async function subscribe(config, email, consent, send, signal) {
    if (config.demo || !config.ready || !consent || !config.company || !config.list) throw new Error('not-ready');
    const response = await send('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(config.company), {
      method:'POST', headers:{'content-type':'application/vnd.api+json',revision:'2026-07-15'},
      body:JSON.stringify(payload(email,config.list,config.source)), signal
    });
    if (response.status !== 202) throw new Error('not-accepted');
    return 'requested';
  }
  if (typeof module !== 'undefined' && module.exports) module.exports={payload,subscribe};
  if (!root.customElements || root.customElements.get('park-newsletter')) return;
  const editorOpen = new Set();
  class ParkNewsletter extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized=true;
      this.events=new AbortController();
      const on=(target,event,handler,options={})=>target.addEventListener(event,handler,{...options,signal:this.events.signal});
      this.designMode=!!root.Shopify?.designMode;
      this.inline=this.dataset.presentation==='inline';
      this.dialog=this.querySelector('dialog');this.opener=this.querySelector('[data-newsletter-open]');
      this.form=this.querySelector('form');this.button=this.form.querySelector('[type="submit"]');
      this.status=this.querySelector('[data-newsletter-status]');
      this.config={demo:this.dataset.demo==='true',ready:this.dataset.ready==='true',company:this.dataset.company,list:this.dataset.list,source:this.dataset.source};
      this.button.disabled=!(this.config.ready||this.config.demo);
      if(this.inline){on(this.form,'submit',e=>this.submit(e));return;}
      this.opener.hidden=false;
      on(this.opener,'click',()=>this.open(this.opener));
      on(this.querySelector('[data-newsletter-close]'),'click',()=>this.dialog.close());
      on(this.dialog,'close',()=>{if(this.designMode&&this.isConnected)editorOpen.delete(this.dataset.sectionId);this.form.querySelector('[name="email"]').value='';this.form.querySelector('[name="consent"]').checked=false;if(this.returnFocus?.isConnected)this.returnFocus.focus();});
      on(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      on(this.form,'submit',e=>this.submit(e));
      if(this.designMode){
        on(document,'shopify:section:select',event=>{if(event.target.contains(this))this.open();});
        on(document,'shopify:block:select',event=>{if(event.target.contains(this)||this.contains(event.target))this.open();});
        if(this.dataset.editorPreview==='true'&&editorOpen.has(this.dataset.sectionId))this.open();
      }else this.setupAutomatic(on);
    }
    open(opener) {
      if(!this.designMode&&!this.deviceAllowed())return false;
      if(this.dialog.open || document.querySelector('dialog[open],.cc-popup--visible')) return false;
      this.returnFocus=opener||document.activeElement;this.dialog.showModal();
      if(this.designMode&&this.dataset.editorPreview==='true')editorOpen.add(this.dataset.sectionId);
      this.dialog.querySelector('h2').focus();
      if(!this.designMode){this.autoShown=true;this.rememberView();this.stopAutomatic();}
      return true;
    }
    deviceAllowed() {
      const device=this.dataset.devices||'desktop';
      return device==='both'||(device==='mobile')===!!this.mobileQuery?.matches;
    }
    storageKey(){return 'park-newsletter-view:'+this.dataset.sectionId;}
    alreadyViewed() {
      try {
        if(this.dataset.autoFrequency==='page')return false;
        if(this.dataset.autoFrequency==='day')return Date.now()-Number(root.localStorage.getItem(this.storageKey())||0)<86400000;
        return root.sessionStorage.getItem(this.storageKey())==='1';
      }catch(_){return false;}
    }
    rememberView() {
      try {
        if(this.dataset.autoFrequency==='day')root.localStorage.setItem(this.storageKey(),String(Date.now()));
        else if(this.dataset.autoFrequency!=='page')root.sessionStorage.setItem(this.storageKey(),'1');
      }catch(_){}
    }
    setupAutomatic(on) {
      this.autoShown=false;this.timeReached=false;
      this.mobileQuery=root.matchMedia('(max-width:760px)');
      const syncDevice=()=>{this.opener.hidden=!this.deviceAllowed();if(this.opener.hidden&&this.dialog.open)this.dialog.close();this.tryAutomatic();};
      on(this.mobileQuery,'change',syncDevice);
      syncDevice();
      if(this.autoShown||this.alreadyViewed()||!this.dataset.autoTrigger||this.dataset.autoTrigger==='manual')return;
      if(['time','either'].includes(this.dataset.autoTrigger))this.autoTimer=root.setTimeout(()=>{this.autoTimer=null;this.timeReached=true;this.tryAutomatic();},Number(this.dataset.autoDelay||15)*1000);
      const schedule=()=>{if(this.autoShown||this.autoFrame)return;this.autoFrame=root.requestAnimationFrame(()=>{this.autoFrame=null;this.tryAutomatic();});};
      if(['scroll','either'].includes(this.dataset.autoTrigger))on(root,'scroll',schedule,{passive:true});
      on(root,'resize',schedule);
      on(document,'visibilitychange',schedule);
      on(document,'close',schedule,{capture:true});
    }
    tryAutomatic() {
      const mode=this.dataset.autoTrigger;
      if(this.designMode||this.autoShown||!mode||mode==='manual'||!this.deviceAllowed()||document.hidden||this.alreadyViewed())return;
      const maxScroll=document.documentElement.scrollHeight-root.innerHeight;
      const scrolled=maxScroll>0&&root.scrollY/maxScroll*100>=Number(this.dataset.autoScroll||50);
      const ready=mode==='time'?this.timeReached:mode==='scroll'?scrolled:this.timeReached||scrolled;
      if(!ready)return;
      const cookie=document.querySelector('#CybotCookiebotDialog');
      const blocked=document.querySelector('dialog[open],.cc-popup--visible')||(cookie&&cookie.getClientRects().length>0)||document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      if(blocked){if(!this.autoRetry)this.autoRetry=root.setTimeout(()=>{this.autoRetry=null;this.tryAutomatic();},1000);return;}
      this.open();
    }
    stopAutomatic() {
      root.clearTimeout?.(this.autoTimer);root.clearTimeout?.(this.autoRetry);root.cancelAnimationFrame?.(this.autoFrame);
      this.autoTimer=null;this.autoRetry=null;this.autoFrame=null;
    }
    setStatus(key) {
      this.status.textContent = this.dataset[key];
      const width = Number(this.dataset[key + 'Width']);
      this.status.style.maxWidth = width > 0 ? `min(100%, ${width}px)` : '';
    }
    async submit(event) {
      event.preventDefault();
      if(this.designMode&&!this.config.demo)return;
      if(this.pending||(!this.config.ready&&!this.config.demo)||!this.form.reportValidity())return;
      const email=this.form.querySelector('[name="email"]').value.trim();
      const consent=this.form.querySelector('[name="consent"]').checked;
      if(!consent)return;
      if(this.config.demo){
        this.setStatus('demoSuccess');
        this.form.querySelector('[name="email"]').value='';
        this.form.querySelector('[name="consent"]').checked=false;
        this.status.focus();return;
      }
      const lifetime=this.events.signal;
      this.pending=true;this.button.disabled=true;this.form.setAttribute('aria-busy','true');
      const labelNodes=[...this.button.childNodes];this.button.textContent=this.dataset.loading;
      const loadingWidth=Number(this.dataset.loadingWidth);
      if(loadingWidth>0){const span=document.createElement('span');span.style.display='inline-block';span.style.maxWidth=`min(100%, ${loadingWidth}px)`;span.textContent=this.dataset.loading;this.button.replaceChildren(span);}
      this.status.textContent='';this.controller=new AbortController();
      const timer=setTimeout(()=>this.controller.abort(),15000);
      try {
        await subscribe(this.config,email,consent,root.fetch.bind(root),this.controller.signal);
        if(lifetime.aborted)return;
        this.setStatus('success');this.form.querySelector('[name="email"]').value='';
        this.form.querySelector('[name="consent"]').checked=false;this.config.ready=false;
      } catch (_) {if(!lifetime.aborted)this.setStatus('error');}
      finally {clearTimeout(timer);if(lifetime.aborted)return;this.pending=false;this.form.removeAttribute('aria-busy');this.button.replaceChildren(...labelNodes);this.button.disabled=!this.config.ready;if(this.inline||this.dialog?.open)this.status.focus();}
    }
    disconnectedCallback(){this.stopAutomatic();this.events?.abort();this.controller?.abort();this.pending=false;this.initialized=false;}
  }
  root.customElements.define('park-newsletter',ParkNewsletter);
})(typeof window==='undefined'?globalThis:window);
